const cookieConsent = localStorage.getItem('cookieConsent');
const isMetaPixalEnabled = cookieConsent === 'accepted';

let pixelScript = null;

export function initMetaPixel(pixelId) {
  if (!pixelId) return;
  if (window.fbq) return;
  if (!isMetaPixalEnabled) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    pixelScript = t;
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}

export function trackEvent(eventName, params = {}) {
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
}

export function destroyMetaPixel() {
  // 移除 script
  if (pixelScript && pixelScript.parentNode) {
    pixelScript.parentNode.removeChild(pixelScript);
    pixelScript = null;
  }

  // 移除全域變數
  delete window.fbq;
  delete window._fbq;
}
